import Button from "components/Button";
import React from "react";

type Props = {
  title: string;
  iconRight?: string;
  iconLeft?: string;
  action: () => void;
  disabled?: boolean;
};

const ButtonJustifyEnd: React.FC<Props> = ({
  title,
  iconRight,
  iconLeft,
  action,
  disabled,
}): JSX.Element => {
  return (
    <div className="flex flex-row justify-end mt-5">
      <Button
        label={title}
        className="h-14 w-32 bg-bt-green text-base text-white rounded-full font-sora font-medium2"
        iconRight={iconRight}
        iconLeft={iconLeft}
        onClick={action}
        disabled={disabled}
      />
    </div>
  );
};

export default ButtonJustifyEnd;
